import React from 'react';
import { createRoot } from 'react-dom/client';

import createHistory from '@guestyci/history/createHistory';

import Root from 'components/Root';
import configureStore from 'store';

import './sass/index.scss';

const history = createHistory();
const store = configureStore(history);

const render = async () => {
  const root = createRoot(document.getElementById('root'));
  root.render(<Root store={store} history={history} />);
};

render();

if (navigator && 'serviceWorker' in navigator) {
  // Remove any service workers that were previously registered
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => registrations.forEach((r) => r.unregister()));
}

if (module.hot) {
  module.hot.accept('components/Root', render);
}
